export default __webpack_public_path__ + "static/media/x-banner.5a8ff2ab.jpeg";